import { NgModule } from '@angular/core';
import { MaterialModule } from './material';
import { CommonModule, NgOptimizedImage, provideImgixLoader } from '@angular/common';
import { NgxPersianModule, IRCurrencyPipe } from 'ngx-persian';

import {
  MoneyPipe,
  JamComponent,
  DigitsFaToEn,
  DigitsEnToFa,
  UserSidenavComponent,
  PersianPaginatorIntl,
  SummaryTextTransformer,
  DragndropFileDirective,
  MinuteSecondPipe,
} from './utilities';

import { CountdownModule } from 'ngx-countdown';
import { HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorComponent } from './components/error/error.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { AppLogoComponent } from './components/app-logo/app-logo.component';
import { FooterComponent } from './../shared/layout/footer/footer.component';

import {
  AddressAddComponent,
  AddressComponent,
  AddressContainerComponent,
  AreYouSureComponent,
  DownloadOrderComponent,
  EditableAddressComponent,
  EditableAddressContainerComponent,
  FilePlaceholderComponent,
  OrderComponent,
} from '../feature';

import { RouterModule } from '@angular/router';
import { DiscountComponent } from './components/discount/discount/discount.component';
import { UserActivatedDiscountContainerComponent } from './components/user-activated-discount-container/user-activated-discount-container.component';
import { DiscountBuyComponent } from './components/discount/discount-buy/discount-buy.component';
import { DiscountContainerComponent } from './components/discount/discount-container/discount-container.component';
import { IfIsServerDirective } from './utilities/directives/if-is-server.directive';
import { IfIsBrowserDirective } from './utilities/directives/if-is-browser.directive';

import {
  MAT_SNACK_BAR_DEFAULT_OPTIONS,
  MatSnackBarConfig,
} from '@angular/material/snack-bar';

import { ImageComponent } from './utilities/components/image/image.component';
// import { NgxViewerModule } from 'ngx-viewer';
import { HelpHoverDirective } from './utilities/directives/help-hover.directive';
import { HelpHoverGroupDirective } from './utilities/directives/help-hover-group.directive';
import { HelpHoverComponent } from './components/help-hover/help-hover.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { EmptyComponent } from './components/empty/empty.component';
import { TalcColorComponent } from './components/order/talc-color-selector/talc-color/talc-color.component';
import { WalletIconComponent } from './layout/header/icons/wallet/wallet.component';
import { DollarIconComponent } from './layout/header/icons/dollar/dolllar.component';
import { PrintIconComponent } from './layout/header/icons/print/print.component';
import { TrackingIconComponent } from './layout/header/icons/tracking/tracking.component';
import { ThesisIconComponent } from './layout/header/icons/thesis/thesis.component';
import { SupportIconComponent } from './layout/header/icons/support/support.component';
import { ZiraxiMagIconComponent } from './layout/header/icons/ziraxi/ziraxi.component';
import { OrderStatusBadgeComponent } from './components/order/order-status-badge/order-status-badge.component';
import { DocScrollDirective } from './utilities/directives/doc-scroll.directive';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    NgxPersianModule,
    CountdownModule,
    ReactiveFormsModule,
    HttpClientModule,
    FlexLayoutModule,
    FormsModule,
    RouterModule,
    CountdownModule,
    // NgxViewerModule,
    OverlayModule,
    NgOptimizedImage,
  ],
  declarations: [
    SummaryTextTransformer,
    MoneyPipe,
    MinuteSecondPipe,
    DigitsEnToFa,
    DigitsFaToEn,
    JamComponent,
    DropdownComponent,
    ErrorComponent,
    AppLogoComponent,
    AddressContainerComponent,
    AddressComponent,
    AddressAddComponent,
    AddressContainerComponent,
    EditableAddressComponent,
    EditableAddressContainerComponent,
    UserActivatedDiscountContainerComponent,
    DiscountComponent,
    OrderComponent,
    DownloadOrderComponent,
    AreYouSureComponent,
    FilePlaceholderComponent,
    FooterComponent,
    DiscountBuyComponent,
    DiscountContainerComponent,
    UserSidenavComponent,
    IfIsServerDirective,
    IfIsBrowserDirective,
    ImageComponent,
    HelpHoverDirective,
    HelpHoverGroupDirective,
    HelpHoverComponent,
    DragndropFileDirective,
    EmptyComponent,
    TalcColorComponent,
    WalletIconComponent,
    DollarIconComponent,
    PrintIconComponent,
    TrackingIconComponent,
    ThesisIconComponent,
    SupportIconComponent,
    ZiraxiMagIconComponent,
    OrderStatusBadgeComponent,
    DocScrollDirective

  ],

  exports: [
    DragndropFileDirective,

    // Components
    DropdownComponent,
    AppLogoComponent,
    AddressContainerComponent,
    JamComponent,
    AreYouSureComponent,
    UserSidenavComponent,
    AddressComponent, // Address <----------
    AddressAddComponent,
    AddressContainerComponent,
    EditableAddressComponent,
    EditableAddressContainerComponent,
    UserActivatedDiscountContainerComponent,
    OrderComponent,
    DownloadOrderComponent,
    IfIsServerDirective,
    ImageComponent,
    IfIsBrowserDirective,
    DiscountComponent, // Discount <----------
    EmptyComponent,
    TalcColorComponent,
    WalletIconComponent,
    DollarIconComponent,
    PrintIconComponent,
    TrackingIconComponent,
    ThesisIconComponent,
    SupportIconComponent,
    ZiraxiMagIconComponent,
    OrderStatusBadgeComponent,
    FooterComponent,
    // Pipes ---------------------------->
    SummaryTextTransformer,
    IRCurrencyPipe,
    MoneyPipe,
    MinuteSecondPipe,
    DigitsEnToFa,
    DigitsFaToEn,
    FilePlaceholderComponent,

    // Modules -------------------------->
    MaterialModule,
    NgxPersianModule,
    ReactiveFormsModule,
    HttpClientModule,
    FlexLayoutModule,
    FormsModule,
    CountdownModule,
    HelpHoverComponent,
    OverlayModule,
    NgOptimizedImage,
    DocScrollDirective,
  ],
  providers: [
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {} as MatSnackBarConfig,
    },
    {
      provide: MatPaginatorIntl,
      useFactory: PersianPaginatorIntl,
    },
    provideImgixLoader('https://ziraxi.com/')
  ],
})
export class SharedModule { }
